var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "150px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "推送类型", prop: "messageType" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.ruleForm.messageType,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "messageType", $$v)
                    },
                    expression: "ruleForm.messageType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("活动消息")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("系统消息")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "目标人群", prop: "targetType" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { input: _vm.onChangeArgetTyp },
                  model: {
                    value: _vm.ruleForm.targetType,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "targetType", $$v)
                    },
                    expression: "ruleForm.targetType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("所有人")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("指定等级")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 3 } }, [_vm._v("指定用户")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2, disabled: "" } }, [
                    _vm._v("指定标签"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.ruleForm.targetType === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "", prop: "targetType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "800px" },
                      attrs: {
                        placeholder: "用户等级",
                        clearable: "",
                        multiple: "",
                      },
                      model: {
                        value: _vm.ruleForm.targetGrades,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "targetGrades", $$v)
                        },
                        expression: "ruleForm.targetGrades",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.grade },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.ruleForm.targetType === 3
            ? _c(
                "el-form-item",
                { attrs: { label: "会员", prop: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSelectMember },
                    },
                    [_vm._v("选择会员")]
                  ),
                  _vm._v(" "),
                  _vm.memberIdObj.length > 0
                    ? _c(
                        "div",
                        _vm._l(_vm.memberIdObj, function (item) {
                          return _c("div", { key: item.memberId }, [
                            _c(
                              "div",
                              {
                                staticClass: "flex",
                                staticStyle: {
                                  "margin-top": "6px",
                                  background: "#F5F7FA",
                                  width: "fit-content",
                                  padding: "0 20px",
                                  "border-radius": "6px",
                                },
                              },
                              [
                                _c("div", { staticClass: "fc" }, [
                                  _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                      "border-radius": "50%",
                                    },
                                    attrs: { src: item.icon, alt: "" },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ml10 ellipsis-multiline",
                                    staticStyle: { width: "120px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.nickname) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "fc",
                                    staticStyle: { "margin-left": "22px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.phone) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "fc  pointer",
                                    staticStyle: { "margin-left": "100px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onListDelMemberId(item)
                                      },
                                    },
                                  },
                                  [_vm._v("\n              x\n            ")]
                                ),
                              ]
                            ),
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "通知标题", prop: "messageTittle" } },
            [
              _c("el-input", {
                staticStyle: { width: "800px" },
                attrs: { placeholder: "请输入标题" },
                model: {
                  value: _vm.ruleForm.messageTittle,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "messageTittle", $$v)
                  },
                  expression: "ruleForm.messageTittle",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "通知内容", prop: "messageContent" } },
            [
              _c("el-input", {
                staticStyle: { width: "800px" },
                attrs: {
                  placeholder: "请输入",
                  rows: 6,
                  type: "textarea",
                  maxlength: "1000",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.ruleForm.messageContent,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "messageContent", $$v)
                  },
                  expression: "ruleForm.messageContent",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "营销位跳转入口", prop: "url" } },
            [
              _c("el-input", {
                staticStyle: { width: "800px" },
                attrs: {
                  placeholder: "请选择活动 or 粘贴链接到此处",
                  clearable: "",
                },
                model: {
                  value: _vm.ruleForm.url,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "url", $$v)
                  },
                  expression: "ruleForm.url",
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "pointer",
                  staticStyle: { color: "#389bff" },
                  on: {
                    click: function ($event) {
                      return _vm.onOfficialEvent()
                    },
                  },
                },
                [_vm._v("\n        去选择\n      ")]
              ),
              _vm._v(" "),
              _vm.ActivityName
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "6px",
                        background: "#eee",
                        width: "fit-content",
                        padding: "0 20px",
                        "border-radius": "6px",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.Display_name) +
                          "--- " +
                          _vm._s(_vm.ActivityName) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "推送时间", prop: "timeType" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { input: _vm.onChangeTargetType },
                  model: {
                    value: _vm.ruleForm.timeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "timeType", $$v)
                    },
                    expression: "ruleForm.timeType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("立即推送")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("定时推送")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("每天推送")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 3 } }, [_vm._v("每周推送")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.ruleForm.timeType === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "选择时间", prop: "timeType" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetime",
                      placeholder: "请选择推送时间",
                    },
                    model: {
                      value: _vm.ruleForm.fixHour,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "fixHour", $$v)
                      },
                      expression: "ruleForm.fixHour",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#E6A23C" } }, [
                    _vm._v("设置的投放时间需大于当前时间至少10分钟"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.ruleForm.timeType === 2 || _vm.ruleForm.timeType === 3
            ? _c("el-form-item", { attrs: { label: "投放日期", prop: "" } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("el-date-picker", {
                      staticClass: "w100",
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "date",
                        placeholder: "开始时间",
                        clearable: "",
                      },
                      model: {
                        value: _vm.ruleForm.startDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "startDate", $$v)
                        },
                        expression: "ruleForm.startDate",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticStyle: { padding: "0 20px" } }, [
                      _vm._v("-"),
                    ]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticClass: "w100",
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "date",
                        placeholder: "结束时间",
                        clearable: "",
                      },
                      model: {
                        value: _vm.ruleForm.endDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "endDate", $$v)
                        },
                        expression: "ruleForm.endDate",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.ruleForm.timeType === 3
            ? _c(
                "el-form-item",
                { attrs: { label: "选择周几", prop: "" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleCheckedCitiesChange },
                      model: {
                        value: _vm.ruleForm.releaseWeek,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "releaseWeek", $$v)
                        },
                        expression: "ruleForm.releaseWeek",
                      },
                    },
                    _vm._l(_vm.cities, function (city) {
                      return _c(
                        "el-checkbox",
                        { key: city.id, attrs: { label: city.id } },
                        [_vm._v(_vm._s(city.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.ruleForm.timeType === 2 || _vm.ruleForm.timeType === 3
            ? _c(
                "el-form-item",
                { attrs: { label: "投放时间", prop: "" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "value-format": "HH:mm:ss",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59",
                      },
                      placeholder: "开始时间",
                    },
                    model: {
                      value: _vm.ruleForm.releaseTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "releaseTime", $$v)
                      },
                      expression: "ruleForm.releaseTime",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#E6A23C" } }, [
                    _vm._v("设置的投放时间需大于当前时间至少10分钟"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v("推送消息")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("ruleForm")
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ActivitySelectionPopup", {
        ref: "activitySelectionPopup",
        on: { SelectEvents: _vm.onSelectEvents },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: "选择会员",
            width: "1200px",
            top: "2vh",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _c("div", [
            _c("div", { staticClass: "frb mt10" }, [
              _c("div", { staticClass: "search_criteria" }, [
                _c(
                  "div",
                  {
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onInquire($event)
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "手机号", clearable: "" },
                      model: {
                        value: _vm.queryData.memberListParam.phone,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.queryData.memberListParam,
                            "phone",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "queryData.memberListParam.phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onInquire($event)
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "用户ID", clearable: "" },
                      model: {
                        value: _vm.queryData.memberListParam.memberId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.queryData.memberListParam,
                            "memberId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "queryData.memberListParam.memberId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onInquire($event)
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "会员昵称", clearable: "" },
                      model: {
                        value: _vm.queryData.memberListParam.nickname,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.queryData.memberListParam,
                            "nickname",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "queryData.memberListParam.nickname",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { width: "fit-content" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onInquire },
                      },
                      [_vm._v("查询")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml10",
                        attrs: { type: "info", plain: "" },
                        on: { click: _vm.onInitialize },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onAddUser },
                    },
                    [_vm._v("添加选中用户")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mt10",
                staticStyle: { height: "600px", overflow: "auto" },
              },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.tableData, border: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "icon",
                        label: "头像",
                        width: "180",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("img", {
                                staticStyle: {
                                  width: "50px",
                                  height: "50px",
                                  "border-radius": "8px",
                                },
                                attrs: {
                                  src:
                                    scope.row.icon ||
                                    "https://ugcore.oss-cn-hangzhou.aliyuncs.com/avatar/ug_user_default_01.png",
                                  alt: "",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "nickname",
                        label: "用户昵称",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "fc" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "nickname_style",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onUserDetails(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(scope.row.nickname) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "memberId",
                        label: "用户ID",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "gradeName",
                        label: "用户等级",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "phone",
                        label: "手机号码",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "操作", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "fc" }, [
                                !_vm.preMemberIdObj.some(function (item) {
                                  return item.memberId === scope.row.memberId
                                })
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "Operation_button",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onAddMemberId(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  选择\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.preMemberIdObj.some(function (item) {
                                  return item.memberId === scope.row.memberId
                                })
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "del_button",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelMemberId(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  删除\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt20 page_box" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.queryData.page.page,
                    "page-sizes": [10, 20, 30, 40],
                    "page-size": _vm.queryData.page.size,
                    layout: "total, prev, pager, next, sizes,jumper",
                    total: _vm.total,
                    background: "",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }